var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse-button"},[_c('button',_vm._g({},_vm.$listeners),[_vm._v(_vm._s(_vm.isOpen ? _vm.closedText : _vm.openText))])])}
var staticRenderFns = []

export { render, staticRenderFns }